import { defineComponent as E, inject as g, ref as y, watch as I, onMounted as P, computed as b, createElementBlock as C, openBlock as M, mergeProps as k, unref as n, createVNode as f, normalizeClass as m, withCtx as u, createElementVNode as x, renderSlot as B, toValue as c } from "vue";
import a from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/JumpLinks/jump-links.js";
import H from "./JumpLinksList.vue2.js";
import J from "../Button.vue2.js";
import S from "../../helpers/AutoWrap.vue2.js";
import "@vueuse/core";
import { JumpLinkInjectionKey as $, JumpLinksKey as V } from "./JumpLinks.vue2.js";
import { useChildrenTracker as w } from "../../use/children-tracker.js";
import { useOUIAProps as A } from "../../helpers/ouia.js";
const K = ["aria-current"], Q = /* @__PURE__ */ E({
  name: "PfJumpLinksItem",
  __name: "JumpLinksItem",
  props: {
    active: { type: Boolean, default: void 0 },
    href: {},
    node: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  emits: ["click"],
  setup(d, { expose: p, emit: v }) {
    const t = d, _ = A({ id: t.ouiaId, safe: t.ouiaSafe }), h = v;
    w(V);
    const e = g($), r = y(null);
    function i() {
      if (typeof t.node == "string") {
        const o = c(e == null ? void 0 : e.scrollableHTMLElement);
        if (o) {
          const l = o.querySelector(t.node) ?? void 0;
          r.value = l instanceof HTMLElement ? l : null;
        }
        return;
      }
      r.value = c(t.node) ?? null;
    }
    I(() => [t.node, e == null ? void 0 : e.scrollableHTMLElement], i), P(i);
    function T(o) {
      h("click", o);
      const l = c(e == null ? void 0 : e.scrollableHTMLElement);
      r.value && l && l.scrollTo({
        top: r.value.offsetTop - ((e == null ? void 0 : e.offset) ?? 0),
        behavior: "smooth"
      });
    }
    const s = b(() => {
      var o;
      return t.active !== void 0 ? t.active : (e == null ? void 0 : e.scrollPosition.value) && (e == null ? void 0 : e.currentTargetPosition.value) && (e == null ? void 0 : e.currentTargetPosition.value) === ((o = r.value) == null ? void 0 : o.offsetTop);
    });
    return p({
      target: r
    }), (o, l) => (M(), C("li", k(n(_), {
      class: [n(a).jumpLinksItem, { [n(a).modifiers.current]: s.value }],
      role: "list",
      "aria-current": s.value ? "location" : void 0
    }), [
      f(S, {
        component: "span",
        exclude: H,
        class: m(n(a).jumpLinksLink)
      }, {
        default: u(() => [
          f(J, {
            variant: "link",
            component: "a",
            href: o.href,
            onClick: T
          }, {
            default: u(() => [
              x("span", {
                class: m(n(a).jumpLinksLinkText)
              }, [
                B(o.$slots, "default")
              ], 2)
            ]),
            _: 3
          }, 8, ["href"])
        ]),
        _: 3
      }, 8, ["class"])
    ], 16, K));
  }
});
export {
  Q as default
};
